<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope45',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '基本水平条形图-scope45',
      timer: null,
      defaultdata: [
        { value1: '门店名称01', value2: '1130' },
        { value1: '门店名称02', value2: '760' },
        { value1: '门店名称03', value2: '730' },
        { value1: '门店名称04', value2: '700' },
        { value1: '门店名称05', value2: '600' },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer)
      this.timer = null
      var echarts = require('echarts');
      var TmyChart = echarts.init(this.$refs.barMian);
      let yValue = this.defaultdata.map(item => item.value1)
      let xValue = this.defaultdata.map(item => item.value2)
      var Toption = {
        color: ['#d84430'],
        tooltip: {
          show: true
        },

        grid: {
          top: '3%',
          bottom: '0%',
          left: '10px',
          right: '5%'
          // containLabel: false
        },
        xAxis: {
          nameTextStyle: {
            color: 'rgba(255, 255, 255, 0.8)',
            align: 'right'
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.8)'
          },
        },

        yAxis: [
          {
            type: "category",
            //升序
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            max: 4,// only the largest 3 bars will be displayed
            axisLabel: {
              show: true,
              inside: true,
              // margin: -5,
              align: "left",
              // overflow: "truncate",
              verticalAlign: 'bottom',
              lineHeight: 40,
              color: '#A1A4AC',
              fontSize: 16,
              formatter: function (value, index) {   // 设置y轴文字拼接
                return 'TOP. ' + (index + 1) + "    " + value

              },
            },
            data: yValue,
          },
          //  {
          //     inverse: true,
          //     data: xValue,
          //     align: "right",
          //     overflow: "truncate",
          //     verticalAlign: 'bottom',
          //     lineHeight: 40,
          //     axisLabel: {
          //         inside: true,
          //         textStyle: {
          //             color: '#FAEC00',
          //             fontSize: 14
          //         },
          //         formatter: '{c}' + '万元'
          //     },
          //     offset: 0,
          //     splitLine: {
          //         show: false
          //     },
          //     axisTick: {
          //         show: false
          //     },
          //     axisLine: {
          //         show: false
          //     }
          // }
        ],
        series: [
          {
            itemStyle: {
              emphasis: {
                barBorderRadius: [5, 5, 5, 5],
              },
              normal: {

                barBorderRadius: [5, 5, 5, 5],
                label: {

                  show: false, //开启显示
                },
                color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                  offset: 0,
                  color: "#0C3F69 " // 0% 处的颜色 
                }, {
                  offset: 0.6,
                  color: "#0A72FC" // 0% 处的颜色
                }, {
                  offset: 1,
                  color: "#0A72FC" // 100% 处的颜色
                }], false)
              },
            },
            type: "bar",
            barWidth: 15,
            barGap: '40%',
            backgroundStyle: {
              color: '#1F2A30', // 背景条的颜色
              barBorderRadius: [5, 5, 5, 5],
            }, label: {
              position: [10, 10], //在右显示
              normal: {
                align: 'right',
                position: [410, -20],
                show: true,
                textStyle: {
                  color: '#FAEC00',
                  fontSize: 14,
                },
                formatter: '{c}' + '万元'
              },
              // textStyle: {
              //     //数值样式
              //     color: '#FAEC00',
              //     fontSize: 14
              // },

            },

            showBackground: true, // 【主要代码】
            data: xValue,
          }]

      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000)
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>